import { gql } from '@apollo/client';

export const ADD_CUSTOM_QUESTION = gql`
  mutation CreateCustomQuestion($question: CreateCustomQuestionInput!) {
    createCustomQuestion(input: $question) {
      __typename
      ... on CreateCustomQuestionResult {
        question {
          id
          text
          questionType
          options {
            id
            text
            order
          }
        }
        validationFailures {
          message
        }
      }
      ... on CreateCustomQuestionErrorResult {
        reason
      }
    }
  }
`;
